var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMicrosoftTeams(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 22.854,
    height: 21.26,
    viewBox: "0 0 22.854 21.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 0.174,
    y1: 1.067,
    x2: 0.826,
    y2: -0.063,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5a62c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#4d55bd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3940ab"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1503.7,777.5h5.9a1.01,1.01,0,0,1,1.01,1.01h0v5.377a3.711,3.711,0,0,1-3.711,3.711h-.018a3.711,3.711,0,0,1-3.712-3.711h0v-5.859a.528.528,0,0,1,.528-.528Z",
    transform: "translate(-1487.755 -769.528)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.392,
    cy: 2.392,
    r: 2.392,
    transform: "translate(17.539 2.126)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 3.455,
    cy: 3.455,
    r: 3.455,
    transform: "translate(9.035 0)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M632.559,777.5h-9.744a1,1,0,0,0-.974,1.022v6.133a5.853,5.853,0,1,0,11.693,0v-6.133A1,1,0,0,0,632.559,777.5Z",
    transform: "translate(-615.462 -769.528)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M628.35,777.5v8.594a.978.978,0,0,1-.606.9.943.943,0,0,1-.367.074H622.44c-.069-.175-.133-.351-.186-.531a6.476,6.476,0,0,1-.282-1.881V778.52a1,1,0,0,1,.973-1.02Z",
    transform: "translate(-615.595 -769.528)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.819,777.5v9.126a.943.943,0,0,1-.074.367.979.979,0,0,1-.9.606H622.69c-.09-.175-.176-.351-.25-.531a5.286,5.286,0,0,1-.186-.531,6.476,6.476,0,0,1-.282-1.881V778.52a1,1,0,0,1,.973-1.02Z",
    transform: "translate(-615.595 -769.528)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.823,777.5v8.063a.98.98,0,0,1-.973.973h-4.592a6.472,6.472,0,0,1-.282-1.881V778.52a1,1,0,0,1,.973-1.02Z",
    transform: "translate(-615.599 -769.528)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M627.288,777.5v8.063a.98.98,0,0,1-.973.973h-4.061a6.47,6.47,0,0,1-.282-1.881V778.52a1,1,0,0,1,.973-1.02Z",
    transform: "translate(-615.596 -769.528)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M894.121,415.641v1.674c-.09.005-.175.011-.266.011s-.175-.005-.266-.011a2.918,2.918,0,0,1-.531-.085,3.455,3.455,0,0,1-2.392-2.03,2.947,2.947,0,0,1-.17-.532h2.652A.976.976,0,0,1,894.121,415.641Z",
    transform: "translate(-881.365 -410.416)",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.01,467.474v1.143a2.916,2.916,0,0,1-.532-.085,3.455,3.455,0,0,1-2.392-2.03h1.951A.976.976,0,0,1,910.01,467.474Z",
    transform: "translate(-897.786 -461.718)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M910.01,467.474v1.143a2.916,2.916,0,0,1-.532-.085,3.455,3.455,0,0,1-2.392-2.03h1.951A.976.976,0,0,1,910.01,467.474Z",
    transform: "translate(-897.786 -461.718)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.472,467.473v1.058a3.455,3.455,0,0,1-2.392-2.03H908.5A.976.976,0,0,1,909.472,467.473Z",
    transform: "translate(-897.779 -461.717)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.974,466.5h9.744a.974.974,0,0,1,.974.974v9.744a.974.974,0,0,1-.974.974H.974A.974.974,0,0,1,0,477.219v-9.744A.974.974,0,0,1,.974,466.5Z",
    transform: "translate(0 -461.717)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.251,728.873H323.3v5.3h-1.241v-5.3h-1.939v-1.029h5.128Z",
    transform: "translate(-316.84 -720.381)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftTeams);
export default __webpack_public_path__ + "static/media/Microsoft_Teams.eb2b41708fdfb27184371b695ac629bc.svg";
export { ForwardRef as ReactComponent };